import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardTicker from './DashboardTicker';

/** Wraps all /dashboards/* routes — keeps the ticker mounted across navigation */
const DashboardLayout: React.FC = () => (
  <>
    <DashboardTicker />
    <Outlet />
  </>
);

export default DashboardLayout;
